import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP: migrations 033/034 + docs/content/13 + docs/content/02 §"March 2026 Impact Summary".

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "I asked my code RAG how a feature worked. It returned three files. None of them exist." },
];

export const SYMPTOM: ScriptLine[] = [
  { scene: "symptom", fromSec: 0.4, holdSec: 6, caption: "At ~75% accuracy it fabricated a clean service → engine → aggregator architecture — pure invention." },
  { scene: "symptom", fromSec: 6.6, holdSec: 5, caption: "The context window had only docs chunks. Zero real implementation code reached the LLM." },
  { scene: "symptom", fromSec: 11.8, holdSec: 4, caption: "Eleven pipeline stages all went green. Nothing looked broken." },
];

export const DIAGNOSIS: ScriptLine[] = [
  { scene: "diagnosis", fromSec: 0.4, holdSec: 6, caption: "So I ran the raw BM25 query by hand. It returned zero rows — and had for weeks." },
  { scene: "diagnosis", fromSec: 6.6, holdSec: 5.5, caption: "plainto_tsquery ANDs every word. No chunk contains all 7 words of a question." },
  { scene: "diagnosis", fromSec: 12.4, holdSec: 3.6, caption: "30% of my hybrid score was dead. Vector-only masked it." },
];

export const FIX1: ScriptLine[] = [
  { scene: "fix1", fromSec: 0.4, holdSec: 6, caption: "Fix one — migration 033: text_to_or_tsquery. Drop stop-words, OR-join the rest." },
  { scene: "fix1", fromSec: 6.6, holdSec: 5.5, caption: "Match more terms, rank higher; match one key term, still surface. BM25 went 0 → 15–20." },
  { scene: "fix1", fromSec: 12.4, holdSec: 4.6, caption: "One SQL function. 75% to 85%. The fabricated files vanished." },
];

export const PLATEAU: ScriptLine[] = [
  { scene: "plateau", fromSec: 0.4, holdSec: 5.5, caption: "Then I plateaued at 85%. More retrieval-side steps gave diminishing returns." },
  { scene: "plateau", fromSec: 6.2, holdSec: 5.8, caption: "handleBatchAnalysis still ranked 11th — because Postgres saw it as one token." },
];

export const FIX2: ScriptLine[] = [
  { scene: "fix2", fromSec: 0.5, holdSec: 6.5, caption: "Fix four — migration 034: split camelCase in the index, then weight the fields." },
  { scene: "fix2", fromSec: 7.2, holdSec: 6.5, caption: "Title is weight A, call-metadata B, full content D — the function name dominates the score." },
  { scene: "fix2", fromSec: 14, holdSec: 7.4, caption: "An index-side fix, not a query tweak. handleBatchAnalysis went rank 11 (0.56) → rank 4 (2.23)." },
];

export const COMPOSE: ScriptLine[] = [
  { scene: "compose", fromSec: 0.4, holdSec: 6, caption: "Ten fixes total, two migrations — the pipeline grew from 11 stages to 16 steps." },
  { scene: "compose", fromSec: 6.6, holdSec: 5.5, caption: "Remove any one and accuracy drops. They only work because they reinforce each other." },
  { scene: "compose", fromSec: 12.4, holdSec: 3.2, caption: "Cross-file code flow went from 0–1 files to 4–5." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 6, caption: "Code-query accuracy: ~75% to a peak of 90%. Two SQL migrations carried most of it." },
  { scene: "payoff", fromSec: 6.6, holdSec: 6, caption: "Documentation queries stayed at ~90% — the fixes targeted code, and didn't regress prose." },
  { scene: "payoff", fromSec: 12.8, holdSec: 5.4, caption: "The biggest lever was the cheapest: one function that fixed dead BM25. A 10-point jump." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.4, caption: "Check the plumbing before you add complexity. A core component can be dead while everything looks green." },
  { scene: "outro", fromSec: 6, holdSec: 3.4, caption: "Next: why my answers were worse than NotebookLM — and how I closed the gap." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
